module.exports = __webpack_public_path__ + "bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bd.svg
// module id = 694
// module chunks = 0